app.controller('popupTreatmentCostSimulationController', ['$scope', '$state', '$mdDialog', '$timeout', '$translate', 'objectHelper', 'baseModel', 'applicationModel', 'treatmentCostSimulationModel', 'icfList', 'visitCardId',
    function ($scope, $state, $mdDialog, $timeout, $translate, objectHelper, baseModel, applicationModel, treatmentCostSimulationModel, icfList, visitCardId) {

        function resolveIcfCategoryLabelKey(code) {
            if (code === 'b') {
                return 'T.MODULE.VISIT.BODY_FUNCTIONS';
            }
            if (code === 'd') {
                return 'T.MODULE.VISIT.ACTIVITIES_AND_PARTICIPATION';
            }
            if (code === 'e') {
                return 'T.MODULE.VISIT.ENVIRONMENT';
            }
            if (code === 's') {
                return 'T.MODULE.VISIT.BODY_STRUCTURES';
            }
            return '';
        }

        function createSimulation() {
            var simulation = new StateOfHealthSimulationVO();

            simulation.suggestedIcd9s = [];
            simulation.simulationEntries = createSimulationEntries();

            return simulation;
        }

        function createSimulationEntries() {
            var simulationEntries = [];

            var icfSortedList = _.sortBy(icfList, function(icf) {
                return resolveIcfCategoryLabelKey(icf.value.substr(0,1));
            });

            icfSortedList.forEach(function(icf) {
                var simulationEntry = new StateOfHealthSimulationIcfEntryVO();

                simulationEntry.icf = icf;

                simulationEntries.push(simulationEntry);
            });

            return simulationEntries;
        }

        function clearSimulationResults() {
            _.each($scope.treatmentCostSimulation.simulationEntries, function(simulationEntry) {
                simulationEntry.postProcedureCost = undefined;
            });
            $scope.calculatedCosts.estimatedCost = 0;
        }

        function refreshGroupedSimulationEntries() {
            $scope.groupedSimulationEntries = _.groupBy($scope.treatmentCostSimulation.simulationEntries, function(simulationEntry) {
                return resolveIcfCategoryLabelKey(simulationEntry.icf.value.substr(0,1));
            });
        }

        function refreshChartConfig() {
            $scope.chartConfig = getChartConfig();
        }

        function calculatePredictedCostSum() {
            var postProcedureCosts = _.map($scope.treatmentCostSimulation.simulationEntries, 'postProcedureCost');
            $scope.calculatedCosts.estimatedCost = _.sum(postProcedureCosts);
        }

        function calculateCostWithoutTreatmentSum() {
            var preProcedureCosts = _.map($scope.treatmentCostSimulation.simulationEntries, 'preProcedureCost');
            $scope.calculatedCosts.costWithoutTreatment = _.sum(preProcedureCosts);
        }

        function setData() {
            $scope.forms = {
                treatmentCostSimulationForm: null
            };
            $scope.treatmentCostSimulation = undefined;
            $scope.groupedSimulationEntries = [];
            $scope.calculatedCosts = {
                selectedIcdCost: 0,
                costWithoutTreatment: 0,
                estimatedCost: 0
            };
            $scope.chartConfig = undefined;
            $scope.requestInProgress = true;
            setHighchartsTranslations();
        }

        function setPermissions() {
        }

        function setListeners() {
            $scope.$on('$destroy', function (event) {
                $scope.requestInProgress = false;
            });

            $scope.$watch('treatmentCostSimulation.selectedIcd9', function(newVal, oldVal) {
                if (!_.isEmpty(oldVal) && _.isEmpty(newVal)) {
                    clearSimulationResults();
                    refreshChartConfig();
                }
            });

            $scope.selectedProcedureCostChange = function() {
                $scope.calculatedCosts.selectedIcdCost = $scope.treatmentCostSimulation.selectedProcedureCost;
                clearSimulationResults();

                $timeout(function() {
                    refreshChartConfig();
                }, 500);
            };

            $scope.preProcedureCostChange = function() {
                calculateCostWithoutTreatmentSum();
                clearSimulationResults();

                $timeout(function() {
                    refreshChartConfig();
                }, 500);
            };

            $scope.$on(Event.TREATMENT_COST_SIMULATION.GET.SUCCESS, function(event, simulation) {
                if (_.isEmpty(simulation)) {
                    $scope.treatmentCostSimulation = createSimulation();
                    treatmentCostSimulationModel.suggest(visitCardId, $scope.treatmentCostSimulation);
                } else {
                    $scope.treatmentCostSimulation = simulation;
                    $scope.requestInProgress = false;
                    $scope.calculatedCosts.selectedIcdCost = $scope.treatmentCostSimulation.selectedProcedureCost;
                    calculateCostWithoutTreatmentSum();
                    calculatePredictedCostSum();
                }
                refreshChartConfig();
                refreshGroupedSimulationEntries();
            });

            $scope.$on(Event.TREATMENT_COST_SIMULATION.SUGGEST.SUCCESS, function(event, simulation) {
                $scope.treatmentCostSimulation = simulation;
                $scope.requestInProgress = false;
                refreshGroupedSimulationEntries();
            });

            $scope.$on(Event.TREATMENT_COST_SIMULATION.RUN.SUCCESS, function(event, simulation) {
                $scope.treatmentCostSimulation = simulation;
                $scope.requestInProgress = false;
                refreshGroupedSimulationEntries();
                calculatePredictedCostSum();
                refreshChartConfig();
            });

            $scope.$on(Event.TREATMENT_COST_SIMULATION.ADD_TO_DATA_SET.SUCCESS, function(event, simulation) {
                $scope.requestInProgress = false;
            });

            $scope.$on(Event.TREATMENT_COST_SIMULATION.SUGGEST.ERROR, function(event, simulation) {
                $scope.requestInProgress = false;
            });

            $scope.$on(Event.TREATMENT_COST_SIMULATION.RUN.ERROR, function(event, simulation) {
                $scope.requestInProgress = false;
            });

            $scope.$on(Event.TREATMENT_COST_SIMULATION.ADD_TO_DATA_SET.ERROR, function(event, simulation) {
                $scope.requestInProgress = false;
            });
        }

        function setActions() {
            $scope.cancel = function() {
                $mdDialog.cancel();
            };

            $scope.setSelectedIcd9 = function($event, procedure) {
                $event.preventDefault();
                $scope.treatmentCostSimulation.selectedIcd9 = procedure;
            };

            $scope.start = function() {
                $scope.requestInProgress = true;
                treatmentCostSimulationModel.run($scope.treatmentCostSimulation);
            };

            $scope.refresh = function() {
                $scope.requestInProgress = true;
                $scope.calculatedCosts.costWithoutTreatment = 0;
                $scope.treatmentCostSimulation = createSimulation();
                treatmentCostSimulationModel.suggest(visitCardId, $scope.treatmentCostSimulation);
            };

            $scope.addToDataSet = function() {
                treatmentCostSimulationModel.addToDataSet($scope.treatmentCostSimulation);
            };
        }

        function configureInterface() {
        }

        function initialize() {
            treatmentCostSimulationModel.get(visitCardId);
        }

        function getChartConfig() {
            return {
                title: {
                    text: ''
                },
                xAxis: {
                    type: 'category',
                    labels: {
                        rotation: -45,
                        style: {
                            fontSize: '13px'
                        }
                    }
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: $translate.instant('T.UI.APPLICATION.COST_ZL'),
                        style: {
                            fontSize: '13px'
                        }
                    },
                    labels: {
                        style: {
                            fontSize: '13px'
                        }
                    }
                },
                series: [{
                    type: 'column',
                    showInLegend: false,
                    data: [
                        {name: $translate.instant('T.MODULE.VISIT.COST_WITHOUT_TREATMENT'), y: $scope.calculatedCosts.costWithoutTreatment, color: '#03af9e'},
                        {name: $translate.instant('T.MODULE.VISIT.PROCEDURE_COST'), y: $scope.calculatedCosts.selectedIcdCost, color: '#314898'},
                        {name: $translate.instant('T.MODULE.VISIT.ESTIMATED_COST'), y: $scope.calculatedCosts.estimatedCost, color: '#2ea9e0'}
                    ],
                    tooltip: {
                        headerFormat: '{point.key}: ',
                        pointFormat: '<b>{point.y} zł</b>',
                        valueDecimals: 2
                    }
                }]
            };
        }

        function setHighchartsTranslations() {
            Highcharts.setOptions({
                lang: {
                    loading: $translate.instant("T.HIGHCHARTS.LOADING"),
                    exportButtonTitle: $translate.instant("T.HIGHCHARTS.EXPORT_BUTTON_TITLE"),
                    printButtonTitle: $translate.instant("T.HIGHCHARTS.PRINT_BUTTON_TITLE"),
                    rangeSelectorFrom: $translate.instant("T.HIGHCHARTS.RANGE_SELECTOR_FROM"),
                    rangeSelectorTo: $translate.instant("T.HIGHCHARTS.RANGE_SELECTOR_TO"),
                    rangeSelectorZoom: $translate.instant("T.HIGHCHARTS.RANGE_SELECTOR_ZOOM"),
                    downloadPNG: $translate.instant("T.HIGHCHARTS.DOWNLOAD_PNG"),
                    downloadJPEG: $translate.instant("T.HIGHCHARTS.DOWNLOAD_JPEG"),
                    downloadPDF: $translate.instant("T.HIGHCHARTS.DOWNLOAD_PDF"),
                    downloadSVG: $translate.instant("T.HIGHCHARTS.DOWNLOAD_SVG"),
                    thousandsSep: $translate.instant("T.HIGHCHARTS.THOUSANDS_SEP"),
                    decimalPoint: $translate.instant("T.HIGHCHARTS.DECIMAL_POINT"),
                    printChart: $translate.instant("T.HIGHCHARTS.PRINT_CHART")
                }
            });

        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);